import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import ComponentImage from "GeneralComponents/ComponentImage";
import LimitedContent from "GeneralComponents/LimitedContent";
import ContentShowItem from "MiniSiteComponents/Carousel/Carousel.interface";
import { ContentShowListProps as Props } from "MiniSiteComponents/ContentShow/ContentShow.interface";
import "./PhotoBoxList.min.css";
import { decodeHtmlEntities } from "../../../Interfaces/utils/Utils";

const PhotoBoxList: React.FC<Props> = (props) => {
  const { componentId, itemsToShowOnLoad, isShowMore, dir, items, noImagesClass, linkTarget, itemsNumberInRow } = props;
  const boxCountClass = getBoxCountClass(items);

  // Drive desktop items-per-row from the `itemsNumberInRow` prop via a CSS custom property.
  // Clamp to a sensible range; values outside it (e.g. the "999" sentinel meaning "show all")
  // fall back to the default layout defined in the stylesheet.
  const itemsPerRow = Number(itemsNumberInRow);
  const ulStyle: React.CSSProperties | undefined =
    Number.isFinite(itemsPerRow) && itemsPerRow > 0 && itemsPerRow <= 6
      ? ({ ["--mst-items-per-row" as never]: itemsPerRow } as React.CSSProperties)
      : undefined;

  function getBoxCountClass(items: ContentShowItem[]) {
    const itemsLength = items.length;

    if (itemsLength === 6) return "mst-Boxes-List-SixItems px-2";
    if (itemsLength === 5) return "mst-Boxes-List-FiveItems px-2";
    return "px-0";
  }

  return (
    <ul
      className={`list-posts mst-Boxes-List d-flex flex-wrap ${noImagesClass} ${boxCountClass} ${"justify-content-" + props.alignment}`}
      style={ulStyle}
      id={"mst-content-list-" + componentId}
    >
      {items.map((item, idx) => {
        const displayItem = idx < itemsToShowOnLoad || isShowMore;

        return (
          <li
            key={item.index}
            className={`list-group-item mst-BoxesListItem  mx-2 ms-md-3 me-md-2 ${displayItem ? "" : "d-none"}`}
          >
            <div className={"mst-boxesListContent "}>
              <div className="overflow-hidden">
                <ComponentImage
                  image={item.image}
                  imageClass="mt-md-4"
                  mobileImage={item.mobileImage}
                  mobileImageClass="mt-3"
                  wrapperDivClass="mst-boxesListView-img"
                  cropAlias="squareImage"
                />

                <div className="mst-boxesListView-itemTextDiv mt-2 px-3">
                  <div className="mst-boxesListView-itemTitle">
                    <div className="mx-auto">
                      <span>{item.title}</span>
                    </div>
                  </div>

                  <div
                    className={`
                                        mst-boxesListView-content content-txt txt 
                                        ${!item.url && !item.link.url ? "no-btn" : ""}
                                    `}
                  >
                    <LimitedContent htmlContent={decodeHtmlEntities(item.content)}></LimitedContent>
                  </div>
                </div>
              </div>

              <div className="align-bottom mst-boxesListView-itemButtonDiv mt-3 mb-md-4 mb-3 txt-pallete-color">
                <CustomLinkButton
                  title={item.title || ""}
                  pageUrl={item.url}
                  link={item.link}
                  isBtn={true}
                  btnClass={"btn btn-outline-primary mst-btn mst-btn-round px-2"}
                  dir={dir}
                  linkIcon={true}
                  linkTarget={linkTarget}
                />
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default PhotoBoxList;
